import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.SelectBankAccountPopup', {
    title: 'Choose bank account',
    save: 'Save',
    otherCurrencies: 'Other currencies',
    noBankAccounts: 'No bank account yet',
    connect: 'Connect one or more bank accounts to make payments',
    addBankAccount: 'Add bank account',
});
